var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pause",
    clipPath: "url(#clip0_2396_75457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.3327 6V26C24.3327 26.5304 24.122 27.0391 23.7469 27.4142C23.3718 27.7893 22.8631 28 22.3327 28H19.9993C19.4689 28 18.9602 27.7893 18.5851 27.4142C18.2101 27.0391 17.9993 26.5304 17.9993 26V6C17.9993 5.46957 18.2101 4.96086 18.5851 4.58579C18.9602 4.21071 19.4689 4 19.9993 4H22.3327C22.8631 4 23.3718 4.21071 23.7469 4.58579C24.122 4.96086 24.3327 5.46957 24.3327 6ZM11.9993 4H9.66602C9.13558 4 8.62687 4.21071 8.2518 4.58579C7.87673 4.96086 7.66602 5.46957 7.66602 6V26C7.66602 26.5304 7.87673 27.0391 8.2518 27.4142C8.62687 27.7893 9.13558 28 9.66602 28H11.9993C12.5298 28 13.0385 27.7893 13.4136 27.4142C13.7886 27.0391 13.9993 26.5304 13.9993 26V6C13.9993 5.46957 13.7886 4.96086 13.4136 4.58579C13.0385 4.21071 12.5298 4 11.9993 4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2396_75457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.b52bea236f4d4dc0e1af591a3852255c.svg";
export { ForwardRef as ReactComponent };